import { sleep } from '@ankr.com/common';
import { BundlePaymentPlan } from 'multirpc-sdk';

export async function fetchBundlePaymentPlansMock(): Promise<
  BundlePaymentPlan[]
> {
  await sleep(1000);

  return [];
}
